import { render, staticRenderFns } from "./diqu.vue?vue&type=template&id=004a8fb8"
import script from "./diqu.vue?vue&type=script&lang=js"
export * from "./diqu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports